import React, { useState } from 'react';

import { Input } from 'ui/Inputs';
import closeIcon from 'assets/img/x.svg';
import plusIcon from 'assets/img/plus.svg';
import visaIcon from 'assets/img/visa-card.svg';
import masterCardIcon from 'assets/img/master-card.svg';
import Modal from 'ui/Modal';
import ModalAddCard from './ModalAddCard';

const ModalPayment = ({ setIsShowModal }) => {
    const [isShowModalAddCard, setIsShowModalAddCard] = useState(false);

    const closeModal = () => {
        setIsShowModalAddCard(true);
        setIsShowModal(false);
    };
    return (
        <>
            <div className="modal-body">
                <div>
                    <div className="modal-header border-bottom-0 align-items px-0 pb-4">
                        <h5 className="modal-title fw-semibold">
                            Payment details
                        </h5>
                        <div
                            onClick={() => setIsShowModal((prev) => !prev)}
                            className="cursor-pointer"
                        >
                            <img src={closeIcon} alt="close" />
                        </div>
                    </div>
                    <h6 className="title-h5">Payment method</h6>
                    <p className="billing--paragraph pt-3">Saved cards</p>

                    <div className="billing--modal-card d-flex align-items-center">
                        <Input
                            className="form-check-input"
                            type="radio"
                            value="current_card"
                            id="current-card"
                        />
                        <label
                            className="form-check-label ms-3"
                            htmlFor="current-email"
                        >
                            <div className="d-flex align-items-start">
                                <div className="mt-1">
                                    <img src={visaIcon} alt="payment" />
                                </div>
                                <div className="d-flex flex-column px-3">
                                    <h5 className="billing--paragraph opacity-100 fw-semibold">
                                        Visa ending in **** 4224
                                    </h5>
                                    <p className="billing--paragraph">
                                        Expiry 06/2024
                                    </p>
                                </div>
                            </div>
                        </label>
                    </div>
                    <div className="billing--modal-card">
                        <Input
                            className="form-check-input"
                            type="radio"
                            value="current_card"
                            id="current-email"
                        />
                        <label
                            className="form-check-label ms-3"
                            htmlFor="current-email"
                        >
                            <div className="d-flex align-items-start">
                                <div className="mt-1">
                                    <img src={masterCardIcon} alt="payment" />
                                </div>
                                <div className="d-flex flex-column px-3">
                                    <h5 className="billing--paragraph opacity-100 fw-semibold">
                                        Master card ending in **** 4224
                                    </h5>
                                    <p className="billing--paragraph">
                                        Expiry 06/2024
                                    </p>
                                </div>
                            </div>
                        </label>
                    </div>
                    <div className="billing--modal-card justify-content-center align-items-center d-flex  cursor-pointer">
                        <div className="d-flex">
                            <img src={plusIcon} alt="" />
                            <p
                                className="billing--paragraph opacity-100 fw-semibold ms-2 "
                                style={{ color: '#0d6efd' }}
                                onClick={closeModal}
                            >
                                Add new payment card
                            </p>
                        </div>
                    </div>
                    <div className="pt-4">
                        <h6 className="title-h5 pb-2">Choose your plan</h6>
                        <div className="billing--modal-card d-flex align-items-center">
                            <Input
                                className="form-check-input m-0"
                                type="radio"
                                value="plan_"
                                id="current-plan"
                            />
                            <label
                                className="form-check-label ms-3 w-100"
                                htmlFor="current-plan"
                            >
                                <div className="d-flex justify-content-between align-items-center mt-1">
                                    <p className="billing--paragraph fw-semibold opacity-100">
                                        Single API
                                    </p>
                                    <p className="billing--paragraph fw-semibold opacity-100">
                                        €0/month
                                    </p>
                                </div>
                            </label>
                        </div>
                        <div className="billing--modal-card d-flex align-items-center ">
                            <Input
                                className="form-check-input m-0"
                                type="radio"
                                value="plan_"
                                id="current-plan"
                            />
                            <label
                                className="form-check-label ms-3 w-100"
                                htmlFor="current-plan"
                            >
                                <div className="d-flex justify-content-between align-items-center mt-1">
                                    <p className="billing--paragraph fw-semibold opacity-100">
                                        Medium
                                    </p>
                                    <p className="billing--paragraph fw-semibold opacity-100">
                                        €30/month
                                    </p>
                                </div>
                            </label>
                        </div>
                        <div className="billing--modal-card d-flex align-items-center ">
                            <Input
                                className="form-check-input m-0"
                                type="radio"
                                value="plan_"
                                id="current-plan"
                            />
                            <label
                                className="form-check-label ms-3 w-100"
                                htmlFor="current-plan"
                            >
                                <div className="d-flex justify-content-between align-items-center mt-1">
                                    <p className="billing--paragraph fw-semibold opacity-100">
                                        Enterprise
                                    </p>
                                    <p className="billing--paragraph fw-semibold opacity-100">
                                        €70/month
                                    </p>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="billing-divider" />
                <div className="d-flex justify-content-between align-items-center pb-4">
                    <p className="title-h5">Total</p>
                    <h3 className="h3-title fw-semibold">€30</h3>
                </div>
                <button className="btn btn-primary w-100">
                    Proceed to Payment
                </button>
                <Modal
                    show={isShowModalAddCard}
                    body={
                        <ModalAddCard
                            setIsShowModal={setIsShowModal}
                            setIsShowModalAddCard={setIsShowModalAddCard}
                        />
                    }
                />
            </div>
        </>
    );
};

export default ModalPayment;
